<template>
    <b-img-lazy :src="imageSrc" alt="" :class="{ 'rounded-circle d-block': !imgSquare }" />
</template>

<script>
import { avatarImage } from '@/helpers/profileImage';

export default {
    props: ['fullString', 'letters', 'imgWidth', 'imgSquare'],

    computed: {
        imageSrc() {
            return avatarImage(this.letters, this.fullString, this.imgWidth);
        }
    }
};
</script>
